export default import.meta.ROLLDOWN_FILE_URL_L9L2B3M93qNjV$H4xjuYrA